import React, { Component } from 'react';
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap} from "react-google-maps";
import styled from "@emotion/styled"
import { useStaticQuery } from "gatsby"
import Img from 'gatsby-image'

const MapsContainerContainer = styled.div`
@media(min-width: 992px){
    display: grid;
    grid-template-columns: 33.3% 33.3% 33.3%;
}
`
const MapsContainer = styled.div`
position: relative;
`
const MapInnerContent = styled.div`
background-color: #0b182c;
    padding: 46px 40px;
    border-radius: 5px;
    font-family: Averta,sans-serif;
    font-weight: 400;
    text-align: center;
    font-size: 18px;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%,-60%);
    color: #fff;
`
const MapLargerText = styled.div`
font-size: 28px;
font-family: "Playfair Display";
font-weight: 400;
`
const DecorativeImage = styled(Img)`
margin-top: 15px;
`
const MapAddress = styled.div`
a{
    color: #828893;
    text-decoration: none;
    line-height: 25px;
    padding: 15px 0;
    display: inline-block;
}
`
const MapPhone = styled.div`
font-size: 18px;
text-transform: uppercase;
a{
    color: #fff;
}
`
const MapPhoneYellow = styled.span`
font-weight: 400;
    color: #f1d19f;
`

const Maps = ({}) => { 
    
    const data = useStaticQuery(graphql`
{
  file(relativePath: { eq: "mapDesignElement.jpg" }) {
      childImageSharp {
        fixed(width: 56, height: 14) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
  }
`)

    return(
        <MapsContainerContainer>
        <MapsContainer>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3052.210459216623!2d-75.1389913481814!3d40.09302037930312!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6b0be9cc223fd%3A0x6f5d3b5455ab363f!2s101%20Greenwood%20Ave%20%23203%2C%20Jenkintown%2C%20PA%2019046!5e0!3m2!1sen!2sus!4v1602617842137!5m2!1sen!2sus" width="100%" height="750" frameborder="0" style={{border: '0'}} allowfullscreen="" ariaHidden="false" tabindex="0"></iframe>
<MapInnerContent>
<MapLargerText>
Jenkintown, PA
</MapLargerText>
<DecorativeImage fixed={data.file.childImageSharp.fixed} loading="lazy"/>
<MapAddress>
<a href="https://www.google.com/maps/dir//101+Greenwood+Ave+Suite+203+Jenkintown,+PA+19046/@40.0837624,-75.1281148,15z/data=!4m2!4m1!3e3" target="_blank">101 Greenwood Ave<br />Suite 203 Jenkintown, PA 19046</a>
</MapAddress>
<MapPhone>
<MapPhoneYellow>Phone: </MapPhoneYellow><a href="tel:2155451870">215-545-1870</a>
</MapPhone>
</MapInnerContent>
       </MapsContainer> 
       <MapsContainer>
       <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.458574575963!2d-75.16808194818384!3d39.953498879320556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6c62e1f253ae3%3A0xcf7305e30b98942f!2s1500%20John%20F%20Kennedy%20Blvd%20%231030%2C%20Philadelphia%2C%20PA%2019102!5e0!3m2!1sen!2sus!4v1602618438276!5m2!1sen!2sus" width="100%" height="750" frameborder="0" style={{border: '0'}} allowfullscreen="" ariaHidden="false" tabindex="0"></iframe>
<MapInnerContent>
<MapLargerText>
Philadelphia, PA
</MapLargerText>
<DecorativeImage fixed={data.file.childImageSharp.fixed} loading="lazy"/>
<MapAddress>
<a href="https://www.google.com/maps/dir//1500+John+F+Kennedy+Boulevard,+Philadelphia,+PA/@39.9534989,-75.1680766,17z/data=!3m1!4b1!4m9!4m8!1m0!1m5!1m1!1s0x89c6c62e1f253ae3:0x8424252f4f2d8993!2m2!1d-75.1658879!2d39.9534989!3e3" target="_blank">1500 John F. Kennedy Blvd.<br />Suite 1030 Philadelphia, PA 19102</a>
</MapAddress>
<MapPhone>
<MapPhoneYellow>Phone: </MapPhoneYellow><a href="tel:2155451870">215-545-1870</a>
</MapPhone>
</MapInnerContent>
       
        </MapsContainer>
        <MapsContainer>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3029.759950768298!2d-75.63095874817246!3d40.591053779243815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c433da4542b29f%3A0xef62d87f927c0c12!2s1275%20Glenlivet%20Dr%20%23100%2C%20Allentown%2C%20PA%2018106!5e0!3m2!1sen!2sus!4v1602618609349!5m2!1sen!2sus" width="100%" height="750" frameborder="0" style={{border: '0'}} allowfullscreen="" ariaHidden="false" tabindex="0"></iframe>
<MapInnerContent>
<MapLargerText>
Allentown, PA
</MapLargerText>
<DecorativeImage fixed={data.file.childImageSharp.fixed} loading="lazy"/>
<MapAddress>
<a href="https://www.google.com/maps/place/1275+Glenlivet+Dr+%23100,+Allentown,+PA+18106/@40.5910579,-75.6309534,17z/data=!3m1!4b1!4m5!3m4!1s0x89c433da4542b29f:0xef62d87f927c0c12!8m2!3d40.5910538!4d-75.6287647" target="_blank">1275 Glenlivet Dr #100 <br />Allentown, PA 18106</a>
</MapAddress>
<MapPhone>
<MapPhoneYellow>Phone: </MapPhoneYellow><a href="tel:2155451870">215-545-1870</a>
</MapPhone>
</MapInnerContent>
       
        </MapsContainer>
        </MapsContainerContainer>
    )
    }
export default Maps;
